import { createSelector } from 'reselect';

import { initialState } from './reducer';

/**
 * Direct selector to the user state domain
 */
export const selectUsersState = () => (state) => state.get('users', initialState);

/**
 * Select the loading state
 */
export const selectLoading = () => createSelector(selectUsersState(), (substate) => substate.loading);

/**
 * Select the loading state
 */
export const selectUsers = () => createSelector(selectUsersState(), (substate) => substate.users);

/**
 * Select non-field errors, raised by the back-end
 */

export const selectErrors = () => createSelector(selectUsersState(), (substate) => substate.errors);
